import { useEffect, useState } from "react";
import { useKeycloak } from "@react-keycloak/web";

import { IUser } from "../types/userTypes";

export const useKeycloakUserInfo = () => {
  const user: IUser = { name: "", email: "", export_screen_enabled: false };
  const [userInfo, setUserInfo] = useState(user);
  const { initialized, keycloak } = useKeycloak();

  useEffect(() => {
    if (initialized) {
      keycloak.loadUserInfo().then((resp: any) =>{
        let newUserInfo:IUser = resp;
        
        if (newUserInfo.export_screen_enabled == null) {
          newUserInfo.export_screen_enabled = false;
        }

        setUserInfo(newUserInfo);
      });
    }
  }, [keycloak, initialized]);
  return { userInfo, initialized, keycloak };
};
